import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-YSZSYFX77X';

export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

export const trackPageView = (path) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const trackEvent = (category, action, label, value) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({ category, action, label, value });
  }
};

export const trackEventByName = (eventName, params = {}) => {
  if (!GA_MEASUREMENT_ID) return;
  const { category, ...rest } = params;
  ReactGA.event({
    category: category || 'engagement',
    action: eventName,
    ...rest,
  });
};
